import { Collapse, Divider, Form } from 'antd';
import { useContext, useEffect, useState } from 'react';
import * as THREE from 'three';
import { DesignerPageContext } from '../../../pages/DesignerPage/DesignerPage';
import ButtonPrimarySmall from '../../common/ButtonPrimary/ButtonPrimarySmall';
import ButtonSecondaryMedium from '../../common/ButtonSecondary/ButtonSecondaryMedium';
import Chip from '../../common/Chip/Chip';
import InputComponent from '../../common/InputComponent/InputComponent';
import SelectComponent from '../../common/SelectComponent/SelectComponent';
import SwitchComponent from '../../common/SwitchComponent/SwitchComponent';
import RightMenuDesign from '../../house/RightMenuDesign/RightMenuDesign';
import { Icon } from '../../icon/icon';
import { CabinetEditorContext } from '../CabinetEditor/CabinetEditor';
import RightDoorHandleCustomDesignMenu from '../RightDoorHandleCustomDesignMenu/RightDoorHandleCustomDesignMenu';
import './RightDoorCustomDesignMenu.scss';
import {
  CeilingDoor,
  DoorDirection,
  InsideType,
} from '../../../constants/enum';
import ButtonSecondarySmall from '../../common/ButtonSecondary/ButtonSecondarySmall';
import i18n from '../../../languages/i18n';
import { useTranslation } from 'react-i18next';
import { Switch } from 'antd';
import RightLiftSupportCustomDesignMenu from '../RightLiftSupportCustomDesignMenu/RightLiftSupportCustomDesignMenu';

const openDirection = [
  {
    value: 'left',
    label: i18n.t('Left to right'),
  },
  {
    value: 'right',
    label: i18n.t('Right to left'),
  },
];

const horizontalTypeOptions = [
  {
    value: '1canh',
    label: i18n.t('1 door'),
  },
  {
    value: '2canh',
    label: i18n.t('2 door'),
  },
];

const ceilingDoor = [
  {
    value: CeilingDoor.WITH_BRACE,
    label: i18n.t('With brace'),
  },
  {
    value: CeilingDoor.WITHOUT_BRACE,
    label: i18n.t('Without brace'),
  },
];

const RightDoorCustomDesignMenu = ({
  open,
  form,
  model,
  className,
  onClickCard,
  beveledDoor,
  setBeveledDoor,
}) => {
  const { t } = useTranslation();
  const designerPageContext = useContext(DesignerPageContext);
  const cabinetEditorContext = useContext(CabinetEditorContext);

  const [doorDirection, setDoorDirection] = useState();
  const [horizontalType, setHorizontalType] = useState();
  const [doorModel, setDoorModel] = useState();
  const [doorSize, setDoorSize] = useState(0);
  const [openHandle, setOpenHandle] = useState(false);
  const [openLiftSupport, setOpenLiftSupport] = useState(false);
  const [hasLock, setHasLock] = useState(false);

  useEffect(() => {
    if (cabinetEditorContext?.meshClickRef?.current) {
      setDoorModel(cabinetEditorContext.meshClickRef.current);
      setDoorDirection(
        cabinetEditorContext.meshClickRef.current.userData?.handlePosition
          ?.current
      );
      setHorizontalType(
        cabinetEditorContext.meshClickRef.current.userData?.horizontalType
      );

      const box = new THREE.Box3().setFromObject(
        cabinetEditorContext.meshClickRef.current
      );
      const size = new THREE.Vector3();
      box.getSize(size);

      setDoorSize(size);
    }
  }, [cabinetEditorContext]);

  useEffect(() => {
    if (!model) {
      setOpenHandle(false);
    }
  }, [model]);

  const formForCurrentCabinet = {
    partitionPlate: [
      {
        key: 'horizontalBoard1',
        label: <span className="text-title-medium">{t('Size')}</span>,
        children: (
          <div className="flex flex-col gap-16 items-start self-stretch">
            <Form.Item label={t('Length')}>
              <InputComponent
                type={'number'}
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={t('Enter')}
                disabled={true}
              />
            </Form.Item>
            <Form.Item label={t('Depth')}>
              <InputComponent
                type={'number'}
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={t('Enter')}
                disabled={true}
              />
            </Form.Item>
            <Form.Item label={t('Height')}>
              <InputComponent
                type={'number'}
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={t('Enter')}
                disabled={true}
              />
            </Form.Item>
          </div>
        ),
      },
    ],
    drawer: [
      {
        key: 'drawer1',
        label: <span className="text-title-medium">{t('Size')}</span>,
        children: (
          <div className="flex flex-col gap-16 items-start self-stretch">
            <Form.Item label={t('Length')}>
              <InputComponent
                type={'number'}
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={t('Enter')}
                disabled={true}
              />
            </Form.Item>
            <Form.Item label={t('Depth')}>
              <div className="flex items-center gap-4">
                <InputComponent
                  type={'number'}
                  addonAfter={<span className="text-body-medium">mm</span>}
                  placeholder={t('Enter')}
                />
              </div>
            </Form.Item>
            <Form.Item label={t('Height')}>
              <InputComponent
                type={'number'}
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={t('Enter')}
              />
            </Form.Item>
          </div>
        ),
      },
      {
        key: 'drawer2',
        label: <span className="text-title-medium">{t('Layout')}</span>,
        children: (
          <div className="flex flex-col gap-16 items-start self-stretch">
            <Form.Item label={t('Top edge distance')}>
              <InputComponent
                type={'number'}
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={t('Enter')}
              />
            </Form.Item>
            <Form.Item label={t('Bottom edge distance')}>
              <InputComponent
                type={'number'}
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={t('Enter')}
              />
            </Form.Item>
          </div>
        ),
      },
    ],
    uDrawer: [
      {
        key: 'uDrawer1',
        label: <span className="text-title-medium">{t('Size')}</span>,
        children: (
          <div className="flex flex-col gap-16 items-start self-stretch">
            <Form.Item label={t('Length')}>
              <InputComponent
                type={'number'}
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={t('Enter')}
                disabled={true}
              />
            </Form.Item>
            <Form.Item label={t('Depth')}>
              <div className="flex items-center gap-4">
                <InputComponent
                  type={'number'}
                  addonAfter={<span className="text-body-medium">mm</span>}
                  placeholder={t('Enter')}
                />
              </div>
            </Form.Item>
            <Form.Item label={t('Height')}>
              <InputComponent
                type={'number'}
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={t('Enter')}
              />
            </Form.Item>
          </div>
        ),
      },
      {
        key: 'uDrawer2',
        label: <span className="text-title-medium">{t('Drawer')}</span>,
        children: (
          <div className="flex flex-col gap-16 items-end self-stretch">
            <div className="flex flex-col items-start gap-12 self-stretch">
              <span className="text-label-medium" style={{ color: '#808B90' }}>
                {t('Drawer layout')}
              </span>
              <div className="flex items-start align-content-start gap-8 self-stretch flex-wrap">
                <Chip
                  posIcon={
                    <span className="flex w-18 h-18">
                      <Icon.ICLayout1 />
                    </span>
                  }
                />
                <Chip
                  posIcon={
                    <span className="flex w-18 h-18">
                      <Icon.ICLayout2 />
                    </span>
                  }
                />
                <Chip
                  posIcon={
                    <span className="flex w-18 h-18">
                      <Icon.ICLayout3 />
                    </span>
                  }
                />
                <Chip
                  posIcon={
                    <span className="flex w-18 h-18">
                      <Icon.ICLayout12 />
                    </span>
                  }
                />
                <Chip
                  posIcon={
                    <span className="flex w-18 h-18">
                      <Icon.ICLayout22 />
                    </span>
                  }
                />
                <Chip
                  posIcon={
                    <span className="flex w-18 h-18">
                      <Icon.ICLayout23 />
                    </span>
                  }
                />
                <Chip
                  posIcon={
                    <span className="flex w-18 h-18">
                      <Icon.ICLayout13 />
                    </span>
                  }
                />
                <Chip
                  posIcon={
                    <span className="flex w-18 h-18">
                      <Icon.ICLayout23 />
                    </span>
                  }
                />
                <Chip
                  posIcon={
                    <span className="flex w-18 h-18">
                      <Icon.ICLayout33 />
                    </span>
                  }
                />
              </div>
            </div>
            <div
              className="flex p-8 flex-col items-start gap-12 self-stretch rounded-[4px]"
              style={{ background: '#F5F6F6' }}
            >
              <div className="text-label-medium" style={{ color: '#808B90' }}>
                {t('Drawer box height')}
              </div>
              <div className="flex items-center gap-16 self-stretch flex-col">
                <Form.Item
                  label={
                    <span className="text-label-medium">
                      {t('Drawer level')} 3
                    </span>
                  }
                >
                  <InputComponent
                    type={'number'}
                    addonAfter={<span className="text-body-medium">mm</span>}
                    placeholder={t('Enter')}
                  />
                </Form.Item>
                <Form.Item
                  label={
                    <span className="text-label-medium">
                      {t('Drawer level')} 2
                    </span>
                  }
                >
                  <InputComponent
                    type={'number'}
                    addonAfter={<span className="text-body-medium">mm</span>}
                    placeholder={t('Enter')}
                  />
                </Form.Item>
                <Form.Item
                  label={
                    <span className="text-label-medium">
                      {t('Drawer level')} 1
                    </span>
                  }
                >
                  <InputComponent
                    type={'number'}
                    addonAfter={<span className="text-body-medium">mm</span>}
                    placeholder={t('Enter')}
                  />
                </Form.Item>
              </div>
            </div>
            <ButtonPrimarySmall title={t('Apply')} />
          </div>
        ),
      },
    ],
    door: [
      {
        key: 'door1',
        label: <span className="text-title-medium">{t('Size')}</span>,
        children: (
          <div className="flex flex-col gap-16 items-start self-stretch">
            <Form.Item label={t('Length')} className="self-stretch">
              <InputComponent
                type={'number'}
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={t('Enter')}
                disabled
                value={Math.round(Math.max(doorSize.x, doorSize.z) * 1000)}
              />
            </Form.Item>

            <Form.Item label={t('Height')} className="self-stretch">
              <InputComponent
                type={'number'}
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={t('Enter')}
                disabled
                value={Math.round(doorSize.y * 1000)}
              />
            </Form.Item>

            <Form.Item label={t('Door thickness')} className="self-stretch">
              <InputComponent
                type={'number'}
                addonAfter={<span className="text-body-medium">mm</span>}
                value={17}
                disabled
              />
            </Form.Item>
          </div>
        ),
      },
      // {
      //   key: "door2",
      //   label: <span className="text-title-medium">Loại cửa</span>,
      //   classNames: { body: "grow" },
      //   children: (
      //     <div className="flex flex-col gap-16 items-start self-stretch grow">
      //       <Form.Item className="self-stretch">
      //         <SelectComponent
      //           options={openDirection}
      //           style={{ flex: "1 0 0" }}
      //           size={"default"}
      //           value={model?.userData?.handlePosition?.current}
      //           onChange={(value) => {
      //             // cabinetEditorContext.insideLoaderRef.current.toggleDoorDirection(
      //             //   model,
      //             //   cabinetEditorContext.clonedModule,
      //             //   value
      //             // );
      //           }}
      //         />
      //       </Form.Item>
      //       <Form.Item label="Độ dày" className="self-stretch">
      //         <InputComponent
      //           type={"number"}
      //           addonAfter={<span className="text-body-medium">mm</span>}
      //           placeholder={17}
      //           disabled
      //         />
      //       </Form.Item>
      //       <Form.Item
      //         name={"cabinetWidthApplyToAll"}
      //         style={{ marginTop: "-10px" }}
      //       >
      //         <div className="flex items-center gap-8 self-stretch">
      //           <Divider
      //             type="vertical"
      //             style={{ margin: 0, height: "24px" }}
      //           />
      //           <ButtonSecondarySmall
      //             posIcon={<Icon.ICSelectAll />}
      //             title={"Áp dụng tất cả"}
      //             onClick={() => {}}
      //           />
      //         </div>
      //       </Form.Item>
      //     </div>
      //   ),
      // },
      {
        key: 'door3',
        label: <span className="text-title-medium">{t('Open direction')}</span>,
        children: (
          <div className="flex flex-col gap-16 items-start self-stretch">
            <Form.Item label={t('Open direction')} className="self-stretch">
              <SelectComponent
                // disabled={
                //   cabinetEditorContext.clonedModule?.moduleType?.includes(
                //     'corner'
                //   ) || model?.userData?.drawerUuid
                //     ? true
                //     : false
                // }
                disabled={
                  doorModel?.userData?.drawerUuid ||
                  doorModel?.userData?.doorDirection ===
                    DoorDirection.HORIZONTAL
                    ? true
                    : false
                }
                options={openDirection}
                style={{ flex: '1 0 0' }}
                size={'default'}
                // value={doorDirection}
                value={
                  doorModel?.userData?.doorDirection ===
                  DoorDirection.HORIZONTAL
                    ? 'Ngang'
                    : doorDirection
                }
                onChange={value => {
                  cabinetEditorContext.insideLoaderRef.current.toggleDoorDirection(
                    doorModel,
                    cabinetEditorContext.clonedModule,
                    value
                  );

                  setDoorDirection(
                    doorModel?.userData?.handlePosition?.current
                  );
                }}
              />
            </Form.Item>

            {doorModel?.userData?.doorDirection ===
              DoorDirection.HORIZONTAL && (
              <Form.Item label={t('Horizontal type')} className="self-stretch">
                <SelectComponent
                  options={horizontalTypeOptions}
                  style={{ flex: '1 0 0' }}
                  size={'default'}
                  value={horizontalType}
                  disabled={doorModel?.userData?.type === InsideType.DOOR_CLONE}
                  onChange={async value => {
                    const newDoor =
                      await cabinetEditorContext.insideLoaderRef.current.toggleHorizontalType(
                        doorModel,
                        cabinetEditorContext.clonedModule,
                        value
                      );

                    setHorizontalType(doorModel?.userData?.horizontalType);

                    if (newDoor) {
                      cabinetEditorContext.meshClickRef.current = newDoor;
                      setDoorModel(newDoor);
                    } else {
                      cabinetEditorContext.meshClickRef.current = null;
                      setDoorModel(null);
                    }

                    // setTimeout(async () => {
                    //   designerPageContext.sceneManager?.handleDrawBorder();
                    //   designerPageContext.sceneManager?.handleDrawBorderSelectedModule(
                    //     foundModule.group,
                    //     true
                    //   );
                    //   await designerPageContext.sceneManager?.calculateTotalCost?.(
                    //     {}
                    //   );
                    // }, 300);
                  }}
                />
              </Form.Item>
            )}

            {/* <Form.Item
              name={"cabinetWidthApplyToAll"}
              style={{ marginTop: "-10px" }}>
              <div className="flex items-center gap-8 self-stretch">
                <Divider
                  type="vertical"
                  style={{ margin: 0, height: "24px" }}
                />
                <ButtonSecondarySmall
                  posIcon={<Icon.ICSelectAll />}
                  title={"Áp dụng tất cả"}
                  onClick={() => {}}
                />
              </div>
            </Form.Item> */}
          </div>
        ),
      },
      {
        key: 'door4',
        label: <span className="text-title-medium">{t('Handle')}</span>,
        children: (
          <div className="flex flex-col gap-16 items-start self-stretch ">
            <Form.Item
              layout="horizontal"
              label={t('No handle')}
              labelCol={{ flex: 'auto' }}
              className="self-stretch"
            >
              <Switch
                className="ml-auto"
                value={beveledDoor}
                onChange={e => {
                  setBeveledDoor(e);

                  const currentCabinet =
                    designerPageContext.sceneManager.cabinetManager.getCurrentCabinet();

                  currentCabinet.changeBevelebCabinet(e);
                  cabinetEditorContext.insideLoaderRef.current.changeBeveledInside(
                    e,
                    currentCabinet.cloneModule
                  );

                  currentCabinet.cloneModule?.group?.traverse(mesh => {
                    if (['DOOR'].some(item => mesh.name.includes(item))) {
                      mesh.userData.beveled = e;
                      mesh.userData.withBrace = CeilingDoor.WITH_BRACE;
                    }

                    if (mesh.userData.type === InsideType.DOOR) {
                      mesh.userData.beveled = e;
                      mesh.userData.withBrace = CeilingDoor.WITH_BRACE;
                    }
                  });

                  setTimeout(() => {
                    cabinetEditorContext.sceneRef.current.handleDrawBorder();
                  }, 0);

                  setTimeout(async () => {
                    await designerPageContext.sceneManager.textureController.reloadTexture(
                      {
                        module: currentCabinet.cloneModule,
                      }
                    );
                  }, 100);
                }}
              />
            </Form.Item>

            <Form.Item
              layout="horizontal"
              label={t('Lock')}
              labelCol={{ flex: '1' }}
              className="self-stretch"
            >
              <Switch
                className="ml-auto"
                // value={beveledDoor}
                value={doorModel?.userData?.lockUuid}
                // onChange={value => {
                //   const foundModule =
                //     designerPageContext.currentCabinet.getModuleByGroupUuid(
                //       designerPageContext.selectedModel.uuid
                //     );

                //   if (!foundModule) return;

                //   if (value) {
                //     //Thêm ổ khóa
                //     const addModelToCabinet = md => {
                //       const data = {
                //         _id: md.userData?.id,
                //         glb: model.userData.default_lock.model,
                //         type: md.userData.type,
                //         name: md.userData.name,
                //         gltfUuid: md.uuid,
                //         gltf: md,
                //       };
                //       md.userData.isInside = true;
                //       md.userData.model = model.userData.default_lock.model;
                //       foundModule.listInside.push(data);
                //       foundModule.group.add(md);
                //     };

                //     const lockModel =
                //       designerPageContext.insideLoaderRef.current.loadLockModel(
                //         model.userData.default_lock,
                //         foundModule,
                //         model,
                //         addModelToCabinet
                //       );

                //     model.userData.lockUuid = lockModel.uuid;
                //     setHasLock(true);
                //   } else {
                //     //Xóa ổ khóa
                //     if (model.userData.lockUuid) {
                //       const oldLock =
                //         designerPageContext.insideLoaderRef.current.findMeshByUuid(
                //           foundModule.group,
                //           model.userData.lockUuid
                //         );

                //       designerPageContext.insideLoaderRef.current.removeInside(
                //         oldLock,
                //         foundModule
                //       );
                //     }

                //     model.userData.lockUuid = null;
                //     setHasLock(false);
                //   }

                //   setTimeout(async () => {
                //     await designerPageContext.sceneManager?.calculateTotalCost?.({});
                //   }, 300);
                // }}
                onChange={value => {
                  const currentCabinet =
                    designerPageContext.sceneManager.cabinetManager.getCurrentCabinet();

                  // currentCabinet.changeBevelebCabinet(value);
                  // cabinetEditorContext.insideLoaderRef.current.changeBeveledInside(
                  //   value,
                  //   currentCabinet.cloneModule
                  // );

                  if (value) {
                    //Thêm ổ khóa
                    const addModelToCabinet = md => {
                      const data = {
                        _id: md.userData?.id,
                        glb: doorModel.userData.default_lock.model,
                        type: md.userData.type,
                        name: md.userData.name,
                        gltfUuid: md.uuid,
                        thumbnail_url: md.userData.thumbnail_url,
                        gltf: md,
                      };
                      md.userData.isInside = true;
                      md.userData.model = doorModel.userData.default_lock.model;
                      currentCabinet.cloneModule.listInside.push(data);
                      currentCabinet.cloneModule.group.add(md);
                    };

                    const lockModel =
                      cabinetEditorContext.insideLoaderRef.current.loadLockModel(
                        doorModel.userData.default_lock,
                        currentCabinet.cloneModule,
                        doorModel,
                        addModelToCabinet
                      );

                    doorModel.userData.lockUuid = lockModel.uuid;
                    setHasLock(true);
                  } else {
                    //Xóa ổ khóa
                    if (doorModel.userData.lockUuid) {
                      const oldLock =
                        cabinetEditorContext.insideLoaderRef.current.findMeshByUuid(
                          currentCabinet.cloneModule.group,
                          doorModel.userData.lockUuid
                        );
                      cabinetEditorContext.insideLoaderRef.current.removeInside(
                        oldLock,
                        currentCabinet.cloneModule
                      );
                    }

                    doorModel.userData.lockUuid = null;
                    setHasLock(false);
                  }

                  // setTimeout(async () => {
                  //   await designerPageContext.sceneManager?.calculateTotalCost?.({});
                  // }, 300);
                }}
              />
            </Form.Item>

            {/* {beveledDoor && (
              <div className="flex flex-col gap-16 items-start self-stretch">
                <Form.Item
                  label={t('Ceiling door brace')}
                  className="self-stretch"
                >
                  <SelectComponent
                    disabled={
                      cabinetEditorContext.clonedModule?.moduleType?.includes(
                        'corner'
                      )
                        ? true
                        : false
                    }
                    options={ceilingDoor}
                    style={{ flex: '1 0 0' }}
                    size={'default'}
                    value={model?.userData?.withBrace}
                    onChange={value => {
                      const currentCabinet =
                        designerPageContext.sceneManager.cabinetManager.getCurrentCabinet();

                      cabinetEditorContext.insideLoaderRef.current.toggleCeilingDoorBrace(
                        model,
                        cabinetEditorContext.clonedModule,
                        value
                      );

                      setTimeout(() => {
                        cabinetEditorContext.sceneRef.current.handleDrawBorder();
                      }, 0);

                      setTimeout(async () => {
                        await designerPageContext.sceneManager.textureController.reloadTexture(
                          {
                            module: currentCabinet.cloneModule,
                          }
                        );
                      }, 0);
                    }}
                  />
                </Form.Item>

                <Form.Item
                  name={'cabinetWidthApplyToAll'}
                  style={{ marginTop: '-10px' }}
                >
                  <div className="flex items-center gap-8 self-stretch">
                    <Divider
                      type="vertical"
                      style={{ margin: 0, height: '24px' }}
                    />
                    <ButtonSecondarySmall
                      posIcon={<Icon.ICSelectAll />}
                      title={t('Apply to all')}
                      onClick={() => {}}
                    />
                  </div>
                </Form.Item>
              </div>
            )}
            <Divider
              type="horizontal"
              className="m-0"
              style={{ color: '#E6E7E7' }}
            /> */}

            {/* Hiển thị phần tuỳ chỉnh tay nắm cho cửa có sử dụng tay nắm */}
            {cabinetEditorContext.insideLoaderRef.current?.beveled ===
              false && (
              <ButtonSecondaryMedium
                title={t('Add handle')}
                preIcon={
                  <span className="w-18 h-18 flex">
                    <Icon.ICAlignForward />
                  </span>
                }
                onClick={() => setOpenHandle(true)}
                className={'self-stretch'}
              />
            )}

            {/* <ButtonSecondaryMedium
              title={t('Add Lift Support')}
              preIcon={
                <span className="w-18 h-18 flex">
                  <Icon.ICAlignForward />
                </span>
              }
              onClick={() => setOpenLiftSupport(true)}
              className={'self-stretch'}
            /> */}
          </div>
        ),
      },
    ],
  };

  return (
    <>
      <RightMenuDesign
        open={open}
        classNames={{
          root: 'top-16 ' + className,
          content: '!p-0 gap-0',
        }}
        header={
          <span className="text-title-large text-nowrap">{t('Kết cấu')}</span>
        }
        content={
          <>
            <Form
              form={form}
              labelAlign="left"
              labelWrap
              colon={false}
              layout="vertical"
              validateTrigger={'onChange'}
              className="left-cabinet-design-menu-body flex flex-col items-start overflow-hidden p-8 gap-8 grow self-stretch"
            >
              <Collapse
                expandIcon={({ isActive }) => (
                  <span className="w-16 h-16 flex">
                    {isActive ? <Icon.ICExpandMore /> : <Icon.ICExpandLess />}
                  </span>
                )}
                defaultActiveKey={['door1', 'door3', 'door4']}
                onChange={() => {}}
                className="self-stretch overflow-auto"
                items={[
                  ...formForCurrentCabinet.door.map(item => ({
                    ...item,
                    onKeyDown: e => {
                      e.stopPropagation();
                    },
                  })),
                ]}
              ></Collapse>
            </Form>
          </>
        }
      />

      <RightDoorHandleCustomDesignMenu
        open={openHandle && doorModel}
        onClose={() => setOpenHandle(false)}
        onClickCard={onClickCard}
      />
      <RightLiftSupportCustomDesignMenu
        open={openLiftSupport && doorModel}
        onClose={() => setOpenLiftSupport(false)}
        onClickCard={onClickCard}
      />
    </>
  );
};

export default RightDoorCustomDesignMenu;
